/* global modForm Modalytics */
import { transformQuadlink } from '../../helpers';
/**
 * If quadlink wasn't transformed, retry via radio and CTA clicks
 */
export function initQuadTransformRetry() {
	modForm.opts.form?.querySelectorAll('.btn-primary, input[type="radio"]').forEach(function(element) {
		if (!element) {
			return;
		}

		element.addEventListener('click', function(e) {
			if (modForm.opts.quadLinkHasBeenTransformed === false && Object.keys(modForm.opts.quadLinkParams).length === 0) {
				e.stopPropagation();
				transformQuadlink();
				Modalytics.heap('track', ['Quad Transform Retry']);
			}
		});
	});
}
